if (!window.Eurus.loadedScript.has('mobile-dock.js')) {
  window.Eurus.loadedScript.add('mobile-dock.js');
  
  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.store('xMobileDock', {
        showDock: true,
        debounce(func, wait) {
          let timeout;
          return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
          };
        },
        initMobileDock() {
          setTimeout(() => {
            const stickyAtc = document.querySelector('.sticky_add_to_cart');
            const containerMobileDock = document.getElementById("mobile-dock-container");
            let heightMobileDock;
            heightMobileDock = containerMobileDock ? containerMobileDock.offsetHeight : 0;
            
            requestAnimationFrame(() => {
              const value = heightMobileDock + "px";
              document.body.style.marginBottom = value;
              if (stickyAtc) {
                stickyAtc.style.setProperty('--height-mobile-dock', value);
              }
            });
          }, 0);
          const updateDock = () => {
            if (window.xViewport.innerWidth > 768) {
              this.showDock = false;
              return;
            }
            this.showDock = true;
          }
          requestAnimationFrame(updateDock)
          window.addEventListener('scroll', this.debounce(updateDock, 50), { passive: true });
        },
        setPositionSearch() {
          const search = document.getElementById('FormSearchMobileDock');
          if (search) {
            const announcement = document.getElementById('x-announcement');
            let height;
            if (announcement) {
              let sticky = announcement?.dataset.isSticky == "true";
              height = sticky ? announcement?.offsetHeight : 0;  
            } else {
              height = 0;
            }
            search.style.setProperty('--announcement-height', `${height}px`);
          }
        }
      });
    });
  });
}
